// Mirror of CommonPdfHobbiesSection.jsx: a single comma-separated line of hobbies.

import { para, run } from "../../shared/wordHelpers";
import { FONT_ARIAL } from "../../shared/wordTheme";

export function buildCommonHobbies( { data } ) {
    const { hobbies } = data;

    const text = hobbies
        .filter( hobby => hobby.text && hobby.text !== "" )
        .sort( ( a, b ) => a.order - b.order )
        .map( hobby => hobby.text )
        .join( ", " );

    return [ para( run( text, { pt: 8, font: FONT_ARIAL } ), { spacing: { after: 0 } } ) ];
}
